import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  BLOOD_ANALYSIS_TYPE,
  BLOOD_ANALYSIS_TYPES,
  BLOOD_ANALYSIS_TYPE_LIST,
} from "#/model/BloodAnalysisTypeCodeList";
import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

// Re-export for backward compatibility
export { BLOOD_ANALYSIS_TYPE, BLOOD_ANALYSIS_TYPE_LIST, BLOOD_ANALYSIS_TYPES };

const baseUrl = "/api/sif/drob/tipKrvneAnalize";

const initialState = {
  tipKrvneAnalizeDtoList: [],
  isLoading: false,
  error: null,
};

/**
 * GET /api/sif/tip_krvne_analize
 */
export const fetchBloodAnalysisTypeCodeList = createAsyncThunk(
  "bloodAnalysisTypeCodeLists/fetchAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const bloodAnalysisTypeCodeListSlice = createSlice({
  name: "bloodAnalysisTypeCodeLists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBloodAnalysisTypeCodeList.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(
      fetchBloodAnalysisTypeCodeList.fulfilled,
      (state, action) => {
        state.isLoading = false;
        state.tipKrvneAnalizeDtoList = action.payload;
      }
    );
    builder.addCase(
      fetchBloodAnalysisTypeCodeList.rejected,
      (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      }
    );
  },
});

export default bloodAnalysisTypeCodeListSlice.reducer;
